$(document).ready(function () {
	//Declare normal variable javascript
	//Hide element when smaller than 1025
	if ($(window).width() < 1025) {
		$(".main-menu-nav").fadeIn(function () {
			$(".main-menu-nav").css({
				display: "flex"
			});
		});
	}

	//Library init
	$.fancybox.defaults.parentEl = "form",
		$('[data-fancybox=""]').fancybox({
			smallBtn: true,
			toolbar: true,
			type: "html",
			clickSlide: 'toggleControls'
		});
	//Declare function Javascript

	toggleMobileMenu();
	swiperInit();
	mappingMenu();
	tabActive();
	// toggleSupport()
	toggleWatchMore();
	toggleSearch();
	try {
		stickyNav();
	} catch (error) {

	}
	filterToggle();
	toggleApplyForm();
	storeIframe();
});

function toggleApplyForm() {
	$(".apply-form .button-apply").on("click", function () {
		$(".form-apply").slideToggle();
	});
}

function toggleSearch() {
	$(".search-toggle").on("click", function (e) {
		$(".searchbox").toggleClass("active");
		e.stopPropagation();
	});
}

function filterToggle() {
	$('.mobile-toggle-filter').on('click', function () {
		$('.mobile-filter').slideToggle();
	})
	$('.remove-filter').on('click', function () {
		$('.mobile-filter').slideUp();
	})
}
$(document).ready(function () {
	jQuery(function ($) {
		"use strict";

		var counterUp = window.counterUp["default"]; // import counterUp from "counterup2"

		var $counters = $(".counter");

		/* Start counting, do this on DOM ready or with Waypoints. */
		$counters.each(function (ignore, counter) {
			var waypoint = new Waypoint({
				element: $(this),
				handler: function () {
					counterUp(counter, {
						duration: 5000,
						delay: 16
					});
					this.destroy();
				},
				offset: "bottom-in-view"
			});
		});
	});
});

$(function () {
	var $ul = $(".sidebar-navigation > ul");

	$ul.find("li .title em").click(function (e) {
		var $li = $(this)
			.parent()
			.parent();

		if ($li.find("ul").length > 0) {
			e.preventDefault();

			if ($li.hasClass("selected")) {
				$li.removeClass("selected")
					.find("li")
					.removeClass("selected");
				$li.find("ul").slideUp(400);
				$li.find(".title em").removeClass("mdi-flip-v");
			} else {
				if ($li.parents("li.selected").length == 0) {
					$ul.find("li").removeClass("selected");
					$ul.find("ul").slideUp(400);
					$ul.find("li .title em").removeClass("mdi-flip-v");
				} else {
					$li.parent()
						.find("li")
						.removeClass("selected");
					$li.parent()
						.find("> li ul")
						.slideUp(400);
					$li.parent()
						.find("> li .title em")
						.removeClass("mdi-flip-v");
				}

				$li.addClass("selected");
				$li.find(">ul").slideDown(400);
				$li.find(">.title>em").addClass("mdi-flip-v");
			}
		}
	});

	$(".sidebar-navigation > ul ul").each(function (i) {
		if ($(this).find(">li>ul").length > 0) {
			var paddingLeft = $(this)
				.parent()
				.parent()
				.find(">li>.title")
				.css("padding-left");
			var pIntPLeft = parseInt(paddingLeft);
			var result = pIntPLeft + 15;

			$(this)
				.find(">li>.title")
				.css("padding-left", result);
		} else {
			var paddingLeft = $(this)
				.parent()
				.parent()
				.find(">li>.title")
				.css("padding-left");
			var pIntPLeft = parseInt(paddingLeft);
			var result = pIntPLeft + 0;

			$(this)
				.find(">li>.title")
				.css("padding-left", result)
				.parent()
				.addClass("selected--last");
		}
	});

	var t = " li > ul ";
	for (var i = 1; i <= 10; i++) {
		$(".sidebar-navigation > ul > " + t.repeat(i)).addClass(
			"sub-menu-" + i
		);
	}

	var activeLi = $("li.selected");
	if (activeLi.length) {
		opener(activeLi);
	}

	function opener(li) {
		var ul = li.closest("ul");
		if (ul.length) {
			li.addClass("selected");
			ul.addClass("open");
			li.find(">.title>em").addClass("mdi-flip-v");

			if (ul.closest("li").length) {
				opener(ul.closest("li"));
			} else {
				return false;
			}
		}
	}
});

function storeIframe() {
	let item = $('.contact-map .item')
	let map = $('#map-wrapper iframe')
	item.on('click', function () {
		let data = $(this).attr('data-src');
		map.attr("src", data)
	})
}

function stickyNav() {
	if ($(".sticky-nav").length) {
		$(".sticky-nav").scrollToFixed({
			zIndex: 99,
			marginTop: $("header").outerHeight(),
		});
		$(".sticky-nav a").on("click", function (event) {
			if (this.hash !== "") {
				let offset =
					$("header").outerHeight() + $(".sticky-nav").outerHeight();
				var hash = this.hash;
				$(".sticky-nav li").removeClass('active')
				$(this).parent().addClass('active')
				$("html, body").animate({
						scrollTop: $(hash).offset().top - offset,
					},
					800,
					function () {
						window.location.hash = hash;
					}
				);
			} // End if
		});
	}
}


function swiperInit() {
	var homerSwiper = new Swiper(".primary-banner .swiper-container", {
		// Optional parameters
		slidesPerView: 1,
		speed: 1205,
		autoplay: {
			delay: 3000
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		},
	});

	var topBanner = new Swiper(".top-banner .swiper-container", {
		// Optional parameters
		speed: 1205,
		slidesPerView: 1,
		autoplay: {
			delay: 3000
		}
	});
	var homeProject = new Swiper(".swiper-project-home .swiper-container", {
		// Optional parameters
		speed: 1205,
		slidesPerView: 1,
		autoplay: {
			delay: 3000
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: ".swiper-project-home .nav-arrow-next",
			prevEl: ".swiper-project-home .nav-arrow-prev"
		}
	});
	var abilitySwiper = new Swiper(".ability-display .swiper-container", {
		// Optional parameters
		speed: 1205,
		slidesPerView: 1,
		autoplay: {
			delay: 3000
		},
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		},
		navigation: {
			nextEl: ".ability-display .nav-arrow-next",
			prevEl: ".ability-display .nav-arrow-prev"
		}
	});

	var quaity = new Swiper(".quality-swiper .swiper-container", {
		// Optional parameters
		spaceBetween: 30,
		speed: 1205,
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1280: {
				slidesPerView: 4,
			}
		},

		autoplay: {
			delay: 3000
		},
		navigation: {
			nextEl: ".quality-swiper .nav-arrow-next",
			prevEl: ".quality-swiper .nav-arrow-prev"
		}
	});

	var partner = new Swiper(".swiper-partner .swiper-container", {
		// Optional parameters
		spaceBetween: 0,
		speed: 1205,
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1280: {
				slidesPerView: 5,
			}
		},

		autoplay: {
			delay: 3000
		},
		navigation: {
			nextEl: ".swiper-partner .nav-arrow-next",
			prevEl: ".swiper-partner .nav-arrow-prev"
		}
	});
	var collectionSwiper = new Swiper(".collection-list .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			}
		},

	});
	var collectionSwiper = new Swiper(".home-certificate .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 30,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 100,
			}
		},

	});


	var aboutAward = new Swiper(".about-award .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		navigation: {
			nextEl: ".about-award  .nav-arrow-next",
			prevEl: ".about-award  .nav-arrow-prev"
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			375: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},

			1280: {
				slidesPerView: 4,
				spaceBetween: 50,
			}
		},

	});
	var aboutPartner = new Swiper(".about-partner .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		navigation: {
			nextEl: ".about-partner  .nav-arrow-next",
			prevEl: ".about-partner  .nav-arrow-prev"
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			350: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 4,
				spaceBetween: 30,
			},

			1280: {
				slidesPerView: 6,
				spaceBetween: 30,
			}
		},

	});

	var otherProject = new Swiper(".swiper-other-project .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		navigation: {
			nextEl: ".swiper-other-project  .nav-arrow-next",
			prevEl: ".swiper-other-project  .nav-arrow-prev"
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			350: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},

			1280: {
				slidesPerView: 3,
				spaceBetween: 30,
			}
		},

	});

	var otherServices = new Swiper(".swiper-other-services .swiper-container", {
		// Optional parameters
		speed: 1205,
		spaceBetween: 30,
		autoplay: {
			delay: 3000
		},
		breakpointsInverse: true,
		navigation: {
			nextEl: ".swiper-other-services  .nav-arrow-next",
			prevEl: ".swiper-other-services  .nav-arrow-prev"
		},
		breakpoints: {
			320: {
				slidesPerView: 1,
				spaceBetween: 0,
			},
			350: {
				slidesPerView: 2,
				spaceBetween: 30,
			},

			1280: {
				slidesPerView: 2,
				spaceBetween: 30,
			}
		},

	});


	$(".four-item-swiper  .swiper-container").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);

		var swiper = new Swiper(".instance-" + index, {
			speed: 750,
			observer: true,
			spaceBetween: 0,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 2,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 4,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			}

		});
	});
	$(" .trinity-item-swiper .swiper-container").each(function (index, element) {
		var $this = $(this);
		$this.addClass("instance-" + index);
		$this.parent().find(".nav-arrow-prev").addClass("btn-prev-" + index);
		$this.parent().find(".nav-arrow-next").addClass("btn-next-" + index);

		var swiper = new Swiper(".instance-" + index, {
			speed: 750,
			observer: true,
			spaceBetween: 0,
			observeParents: true,
			breakpointsInverse: true,
			breakpoints: {
				200: {
					slidesPerView: 2,
				},
				576: {
					slidesPerView: 2,
				},
				769: {
					slidesPerView: 3,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			navigation: {
				nextEl: ".btn-next-" + index,
				prevEl: ".btn-prev-" + index
			}

		});
	});

	var galleryThumbs = new Swiper('.gallery-thumbs', {
		spaceBetween: 10,
		breakpointsInverse: true,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 6,
			},
			1280: {
				slidesPerView: 10,
			}
		},
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var galleryTop = new Swiper('.gallery-top', {
		spaceBetween: 0,
		navigation: {
			nextEl: '.nav-next',
			prevEl: '.nav-prev',
		},
		thumbs: {
			swiper: galleryThumbs
		}
	});
	var projectThumb = new Swiper('.project-thumbs .swiper-container', {
		spaceBetween: 10,
		breakpointsInverse: true,
		clickable: true,
		breakpoints: {
			320: {
				slidesPerView: 2,
			},
			576: {
				slidesPerView: 3,
			},
			768: {
				slidesPerView: 4,
			},
			1280: {
				slidesPerView: 4,
			}
		},
		freeMode: true,
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
	});
	var projectTop = new Swiper('.project-top .swiper-container', {
		spaceBetween: 0,
		navigation: {
			nextEl: '.nav-arrow-next',
			prevEl: '.nav-arrow-prev',
		},
		thumbs: {
			clickable: true,
			swiper: projectThumb
		}
	});


	var productThumbs = new Swiper(
		".swiper-product-thumbs  .swiper-container", {
			spaceBetween: 30,
			freeMode: false,
			breakpointsInverse: true,
			breakpoints: {
				320: {
					slidesPerView: 3,
					direction: "horizontal",
					spaceBetween: 10,
				},
				576: {
					slidesPerView: 3,
					direction: "horizontal",

				},
				1025: {
					slidesPerView: 4,
					spaceBetween: 10,
					direction: "vertical"
				},
				1440: {
					slidesPerView: 4,
					spaceBetween: 10,
					direction: "vertical"
				}
			},
			watchSlidesVisibility: true,
			watchSlidesProgress: true,

		}
	);

	var productMain = new Swiper(".swiper-product-main .swiper-container", {
		slidesPerView: 1,
		centeredSlides: true,
		effect: "fade",

		fadeEffect: {
			crossFade: true
		},
		speed: 750,
		loop: false,
		thumbs: {
			swiper: productThumbs
		}

	});
}


//Mapping

function mappingMenu() {
	return new MappingListener({
		selector: ".head-wrap-center",
		mobileWrapper: ".mobile-wrapper",
		mobileMethod: "appendTo",
		desktopWrapper: ".head-wrap-right",
		desktopMethod: "insertBefore",
		breakpoint: 1025
	}).watch();
}

//Toggle Plugin

function toggleItem() {
	$(".toggle-item > .title").click(function (e) {
		e.preventDefault();
		if (
			!$(this)
			.parent()
			.hasClass("active")
		) {
			$(".toggle-item article").slideUp();
			$(this)
				.next()
				.slideToggle();
			$(".toggle-item").removeClass("active");
			$(this)
				.parent()
				.addClass("active");
		} else {
			$(this)
				.next()
				.slideToggle();
			$(".toggle-item").removeClass("active");
		}
	});
}
//Toggle watch more
function toggleWatchMore() {

	let button = $(".read-more-wrapper .btn-view-more");
	let content = $(".read-more-wrapper .content-text ");
	button.on("click", function () {
		content.toggleClass('active')
	});

}
//Link to section

//Tab active
function tabActive() {
	$(".tab-navigation li a").on("click", function () {
		$(this)
			.parents(".tab-navigation")
			.find("li")
			.removeClass("active");
		$(this)
			.parents("li")
			.addClass("active");

		var display = $(this).attr("data-type");
		$(".tab-item").removeClass("active");
		$("#" + display).addClass("active");
	});
}

//Toggle mobile menu
function toggleMobileMenu() {
	var $hamburger = $(".hamburger");
	$(".main-menu-toggle").on("click", function () {
		$(".mobile-wrapper").toggleClass("active");
		$hamburger.toggleClass("is-active");
	});
}

$(document).on("click", ".wrapper video", function (e) {
	$(this).removeAttr("poster");
	var video = $(this).get(0);
	if (video.paused === false) {
		video.pause();
		$(this)
			.parent()
			.find(".play__icon")
			.fadeIn();
	} else {
		video.play();
		$(this)
			.parent()
			.find(".play__icon")
			.fadeOut();

	}
	return false;
});
